'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true,
});
exports.default = void 0;
var COLORS = [
  'gray-900',
  'gray-800',
  'gray-700',
  'gray-600',
  'gray-500',
  'gray-400',
  'gray-200',
  'gray-100',
  'white',
  'black',
  'transparent',
  'red-900',
  'red-800',
  'red-600',
  'red-500',
  'red-400',
  'red-200',
  'red-100',
  'orange-900',
  'orange-800',
  'orange-600',
  'orange-500',
  'orange-400',
  'orange-200',
  'orange-100',
  'yellow-900',
  'yellow-800',
  'yellow-600',
  'yellow-500',
  'yellow-400',
  'yellow-200',
  'yellow-100',
  'green-900',
  'green-800',
  'green-600',
  'green-500',
  'green-400',
  'green-200',
  'green-100',
  'teal-900',
  'teal-800',
  'teal-600',
  'teal-500',
  'teal-400',
  'teal-200',
  'teal-100',
  'blue-900',
  'blue-800',
  'blue-600',
  'blue-500',
  'blue-400',
  'blue-200',
  'blue-100',
  'indigo-900',
  'indigo-800',
  'indigo-600',
  'indigo-500',
  'indigo-400',
  'indigo-200',
  'indigo-100',
  'purple-900',
  'purple-800',
  'purple-600',
  'purple-500',
  'purple-400',
  'purple-200',
  'purple-100',
  'pink-900',
  'pink-800',
  'pink-600',
  'pink-500',
  'pink-400',
  'pink-200',
  'pink-100',
];
var _default = COLORS;
exports.default = _default;
